import {
  HeaderTabs,
  type TabWithIndicatorProps,
} from "@/components/Navigation/HeaderTabs";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { useParams } from "@tanstack/react-router";

export default function GroupIdHeaderTabs() {
  const proxyUserId = useParams({
    from: "/_staff/id-managements/group-id/$id/_$id",
  }).id;
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.idManagements.groupId.details.tabs",
  });

  const links: TabWithIndicatorProps[] = [
    {
      to: "/id-managements/group-id/$id/members",
      params: { id: proxyUserId },
      children: t("members"),
    },
    {
      to: "/id-managements/group-id/$id/rule-and-policy",
      params: { id: proxyUserId },
      children: t("ruleAndPolicy"),
    },
    {
      to: "/id-managements/group-id/$id/settings",
      params: { id: proxyUserId },
      children: t("settings"),
    },
  ];

  return <HeaderTabs tabs={links} />;
}
